import Image from '@components/Image';
import { onPlayerViewChange } from '@modules/player/actions/viewActions';
import { $loadedScene } from '@stores/loadedStore';
import { ImageType } from '@types';
import { useStore } from 'effector-react';
import { type CSSProperties, useEffect, useState } from 'react';
import { COMPASS_DEFAULT } from '../constants';

export function CompassWidget({ viewMode }: { viewMode: 'pc' | 'mobile' }) {
  const data = useStore($loadedScene)!;
  const {
    enabled,
    mediaId,
    mediaUrl,
    position = COMPASS_DEFAULT.position,
  } = data.config.compass ?? COMPASS_DEFAULT;
  const { north } = data;
  const [currentHLookAt, setCurrentHLookAt] = useState(data.view.hLookAt);

  useEffect(() => {
    // 修正场景切换太快导致全景还未加载时无法回调当前视角导致指南针方向错误问题
    setTimeout(() => {
      setCurrentHLookAt(north);
    }, 500);
    return onPlayerViewChange.watch((view) => {
      setCurrentHLookAt(view.hlookat);
    });
  }, [north]);

  if (!enabled) {
    return null;
  }

  const getPosStyle = (): CSSProperties => {
    if (position === 'bottom') {
      /**
       * 1.当选择了"底部居中"选项后,在全景底部居中出现指北针.
       * 2.当底部居中时,PC 端指北针的图片放大到 200 x 200PX.图片露出 50PX.
       * 3.底部居中时,移动端指北针图片以150 x 150 px 显示,图片露出 40pX.
       */
      const size = viewMode === 'mobile' ? 150 : 200;
      const bottom = viewMode === 'mobile' ? 40 - size : 50 - size;
      return {
        bottom,
        width: size,
        height: size,
      };
    }
    return { top: 20, left: 20, width: 100, height: 100 };
  };

  return (
    <Image
      src={mediaUrl}
      draggable={false}
      type={mediaId === 0 ? ImageType.sysMedia : ImageType.media}
      className="absolute select-none"
      style={{
        ...getPosStyle(),
        transform: `rotate(${north - currentHLookAt}deg)`,
      }}
    />
  );
}
